import { Box, BoxProps, ColorOptions, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'
import { flatten } from 'lottie-colorify'
import Lottie from 'react-lottie'
import { isValidColorCode } from '../../utils'

import { useStores } from '../../data/store'
const loader = require('../../assets/images/pg_loader.json')
export const FallbackScreen = () => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: isValidColorCode(theme?.brandColor) ? flatten(theme?.brandColor, loader) : loader,
  }
  return (
    <Box {...styles(theme).mainViewWrap}>
      <Lottie options={defaultOptions} height={60} width={60} />
      <Spacer size={12} />
      <TextNew {...styles(theme).loadingText}>{'Loading'}</TextNew>
    </Box>
  )
}

const styles = (theme: any) => ({
  mainViewWrap: {
    f: 1,
    backgroundColor: theme.bodyBgColor as ColorOptions,
    justify: 'center',
  } as BoxProps,
  loadingText: {
    type: 'bodyMedium14',
    textAlign: 'center',
    color: theme.brandColor as ColorOptions,
  } as TextNewProps,
})
